import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DataTables"
import MetaTag from "components/Common/Meta-tag"

function Challan() {
  return (
    <>
      <MetaTag title={"All Challans"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All Challans" />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Challan
